module.exports = __webpack_public_path__ + "img/xiaoban.7353f0ae.png";